// AppInstallReporter - Lapor status pemasangan PWA ke backend secara automatik
// - Bila app dibuka dalam mod standalone (bermakna PWA sudah dipasang) -> report
// - Bila event 'appinstalled' berlaku semasa user log masuk -> report
// Laporan dihantar sekali sehari sahaja bagi setiap user (localStorage throttle)
import { useEffect } from "react";
import { axiosInstance } from "../../config/api";

const THROTTLE_KEY = "app-install-reported";
const ONE_DAY = 24 * 60 * 60 * 1000;

async function reportInstall(mode) {
  try {
    await axiosInstance.post("/app-install/report", {
      installed: true,
      platform: navigator.userAgent || "",
      mode,
    });
    localStorage.setItem(THROTTLE_KEY, JSON.stringify({ ts: Date.now() }));
  } catch (err) {
    // Senyap - jangan ganggu pengguna jika gagal
    console.debug("app-install report failed:", err?.message);
  }
}

export default function AppInstallReporter({ user }) {
  useEffect(() => {
    if (!user) return;

    // 1) Jika sedang berjalan dalam mod standalone = app sudah dipasang
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true; // iOS Safari

    if (isStandalone) {
      try {
        const cached = JSON.parse(localStorage.getItem(THROTTLE_KEY) || "null");
        if (!cached || Date.now() - cached.ts > ONE_DAY) {
          reportInstall("standalone");
        }
      } catch {
        reportInstall("standalone");
      }
    }

    // 2) Dengar event appinstalled (pemasangan baru semasa sesi ini)
    const onInstalled = () => reportInstall("appinstalled-event");
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, [user]);

  return null;
}
